

import { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { CertificateCorporateListConfig } from "./data/CertificateCorporateListConfig";
import { useNavigate } from "react-router-dom";
import { CertificateCorporateListdata } from "./data/CertificateCorporateList.data";

const CertificateCorporateList = () => {
  const navigate = useNavigate()
  const molGridRef = useRef();
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(CertificateCorporateListdata);
  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    endPage: 100,
    CompanyUENNumber: null,
    totalCount: 0,
    MembershipTypeId: null,
    StatusId: null,
  });

  // const actionHandler = {
  //   UPDATE: handleProcessClick,
  // };

  return (
    <div className="corporate-member-list member-application-task-list">
      <div className="member-list-filter row">
        <div className="row status-input">

          <FormCreator
            ref={MemberApplicationRef}
            {...formData}
          />

        </div>
        <div className="right-side-btn pr-3">

          <Buttons
            buttonText="Search"
            buttonTypeClassName="success-btn"
          // onClick={handleSearch}
          />
        </div>
      </div>

      <div className="member-list membership-app-list certificate-corporate-list">
        <div>
          <h4> 55 Corporate Members</h4>
        </div>
        <MolGrid
          ref={molGridRef}
          configuration={CertificateCorporateListConfig}
          dataSource={dataSource}
          allowPagination={true}
          pagination={paginationRequest}
        // onPageChange={handlePageChange}
        // onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default CertificateCorporateList;
